import { Skeleton, Typography } from '@mui/material';
import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { CfDataGridTableViewDefinitions } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { RecipeGridRowImage } from '../../../recipes/components/RecipeGrid/RecipeGridRowImage';

export const hiddenRecipesTableView = (): CfDataGridTableViewDefinitions<RecipeHeader> => {
  return {
    xs: {
      showHeader: false,
      bodyTableRowProps: () => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      }),

      columns: [
        {
          title: '',
          width: 'fit-content',
          value: function RecipeImage(props) {
            return <RecipeGridRowImage imageUrl={props.item.ImageUrl} size='small' />;
          },
          loadingPlaceholder: <Skeleton width='100px' height='100px' />,
        },
        {
          title: '',
          width: 'fit-content',
          value: function RecipeName(props) {
            return (
              <Typography variant='responsiveParagraph' textAlign='left'>
                {props.item.RecipeName}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton width='40svw' height='30px' sx={{ maxWidth: '300px' }} />,
        },
      ],
    },
  };
};
